"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function RedeemField({ value, onChange, onKeyDown, className, onMouseDown, onBlur, disabled, outline, ariaLabeledBy, ariaLabel, inputIndex, }, ref) {
    const innerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (ref === null || !ref) {
            return;
        }
        if (typeof ref === 'function') {
            ref(innerRef.current);
            return;
        }
        ref.current =
            innerRef.current;
    }, [innerRef, ref]);
    const onFocus = () => {
        innerRef.current.setSelectionRange(0, innerRef.current.value.length);
    };
    return ((0, jsx_runtime_1.jsx)(Input, { ref: innerRef, value: value, onFocus: onFocus, onChange: onChange, onKeyDown: onKeyDown, className: className, onMouseDown: onMouseDown, onBlur: onBlur, disabled: disabled, outline: outline, "aria-labelledby": ariaLabeledBy, "aria-label": ariaLabel, id: `input-${inputIndex}`, "data-e2e": 'RedeemField_Input' }));
}
exports.default = (0, ui_1.withA11y)((0, react_1.forwardRef)(RedeemField));
const Input = styled_components_1.default.input `
  width: 40px;
  height: 43px;

  margin: 0 15px 5px 0;
  padding: 0;

  color: ${({ theme }) => theme.designSystem.text};

  font-weight: 100;
  font-size: 18px;
  text-align: center;

  background-color: ${({ theme }) => theme.designSystem.contentBackground};
  border: none;
  border-bottom: 1px solid
    ${({ theme }) => theme.designSystem.highlightedBorder};
  border-radius: 0;

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      opacity: 0.3;
    `}
  &:focus {
    border-color: ${({ theme }) => theme.designSystem.accent};

    outline-offset: 3px;
  }

  ${ui_1.device.mobileL((0, styled_components_1.css) `
    flex-direction: row;
    margin: 0 8px 5px 0;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin: 0 5px 5px 0;
    height: 36px;
    width: 28px;
  `)}
`;
